import { request } from '@/common';
import CryptoJS from 'crypto-js';

const secret = '7A@qFKu6WwgQp#&&E&8BDJ4e&caZY2bJ';

const decrypt = (content) => {
  const key = CryptoJS.enc.Utf8.parse(secret);
  return CryptoJS.AES.decrypt(content, key, {
    iv : key,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  }).toString(CryptoJS.enc.Utf8);
}

export async function getSpeechToken() {
  try {
    return await request.get(`/asr/speech/options/v2`, {
      params: { type: 'speech_key' },
    })
    .then(res => {
      const speech_key = res.data?.speech_key;
      if(!speech_key){
        return res;
      }
      try{
        res.data.speech_key = decrypt(res.data.speech_key);
        res.data.speech_region = decrypt(res.data.speech_region);
      } catch(e){}
      return res;
    })
  } catch (error) {
    return error;
  }
}
